var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgViewLink(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 11,
    viewBox: "0 0 15 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.65333 6.90335C8.49312 7.07528 8.29992 7.21319 8.08526 7.30884C7.87059 7.40448 7.63886 7.45592 7.40389 7.46006C7.16891 7.46421 6.93551 7.42098 6.71761 7.33297C6.4997 7.24495 6.30175 7.11395 6.13558 6.94777C5.9694 6.78159 5.8384 6.58365 5.75038 6.36574C5.66236 6.14784 5.61914 5.91444 5.62329 5.67946C5.62743 5.44449 5.67886 5.21276 5.77451 4.99809C5.87016 4.78343 6.00806 4.59023 6.18 4.43002M10.8817 9.13168C9.88451 9.89177 8.67031 10.3129 7.41667 10.3333C3.33333 10.3333 1 5.66668 1 5.66668C1.7256 4.31445 2.732 3.13304 3.95167 2.20168L10.8817 9.13168ZM6.19167 1.14001C6.59319 1.04603 7.00429 0.999046 7.41667 1.00001C11.5 1.00001 13.8333 5.66668 13.8333 5.66668C13.4792 6.32912 13.0569 6.95278 12.5733 7.52751L6.19167 1.14001Z",
    stroke: "#8D8599",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewLink);
export default __webpack_public_path__ + "static/media/view-link.c5de7faf.svg";
export { ForwardRef as ReactComponent };